import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AbsenceService = {
    list: async () => axios.get(API_URL + "/absences/list").then((data) => data).catch((err) => { throw err }),
    usersSummary: async () => axios.get(API_URL + "/user/getUser/usersSummary").then((data) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_KEEPER + `/absences/${id}`).then(({data}) => data).catch((err) => { throw err }),
    imageId: async () => axios.get(API_KEEPER + "/ged/attach/createId").then((data) => data).catch((err) => { throw err }),
    image: async (id) => axios.get(API_URL + `/attach/${id}`, {responseType: "blob"})
        .then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(API_KEEPER + `/absences/save`, data, {headers: {"Content-Type": "multipart/form-data"}}).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(API_KEEPER + `/absences/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default AbsenceService;